<template>
  <el-dialog title="修改" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" :model="formData" :rules="formRules" ref="form">
      
      <!--类型-->
      <el-form-item label="类型" prop="type" :label-width="formLabelWidth">
        <el-select v-model="formData.type_id">
          <el-option :value="item.key_name" :label="item.name" :key="item.key_name" v-for="item in type"></el-option>
        </el-select>
      </el-form-item>

      <!--名称-->
      <el-form-item label="名称" prop="name" :label-width="formLabelWidth">
        <el-input v-model="formData.name" autocomplete="off" placeholder="请输入名称"></el-input>
      </el-form-item>

      <!--年份-->
      <el-form-item label="年份" prop="year" :label-width="formLabelWidth">
        <el-input v-model="formData.year" autocomplete="off" placeholder="请输入年份"></el-input>
        <p class="gray9">类型为真题才需要填写</p>
      </el-form-item>

      <!--满分分数-->
      <el-form-item label="满分分数" prop="full_score" :label-width="formLabelWidth">
        <el-input v-model="formData.full_score" autocomplete="off" placeholder="请输入"></el-input>
      </el-form-item>

      <!--及格分数-->
      <el-form-item label="及格分数" prop="pass_score" :label-width="formLabelWidth">
        <el-input v-model="formData.pass_score" autocomplete="off" placeholder="请输入"></el-input>
      </el-form-item>

      <!--时限(分)-->
      <el-form-item label="时限(分)" prop="minute" :label-width="formLabelWidth">
        <el-input v-model="formData.minute" autocomplete="off" placeholder="请输入"></el-input>
      </el-form-item>

      <el-form-item label="备注" prop="remark" :label-width="formLabelWidth">
        <el-input type="textarea" v-model="formData.remark" :rows="5" placeholder="请输入备注"></el-input>
      </el-form-item>

      <!--是否显示-->
      <el-form-item label="是否显示" prop="status" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.status">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>
      
    </el-form>
    <!--操作按钮-->
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="onSubmit()" :disabled="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import ShuatiApi from '@/api/study/shuati.js';
import { deepClone } from '@/utils/base.js';
export default {
  data() {
    return {
      /*是否加载中*/
      loading: false,
      /*form表单数据对象*/
      formData: {
        name: '',
        type: '',
        year: '',
        full_score: '',
        pass_score: '',
        minute: '',
        remark: '',
        status: 1,
      },
      /*验证规则*/
      formRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
      },
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
    };
  },
  props: {
    open_edit:Boolean,
    selectModel:Object,
    type:Object,
  },
  created() {
    this.dialogVisible = this.open_edit;
    this.formData = this.selectModel;
    console.log(this.formData.type);
    // this.formData.type = this.formData.type.value ? this.formData.type.value : '';
    // console.log(this.formData);
  },
  methods: {
    /*修改分类*/
    onSubmit() {
      let self = this;
      let params = self.formData;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          ShuatiApi.edit(params, true)
            .then(res => {
              if (res.code == 1) {
                self.$message({
                  message: res.msg,
                  type: 'success',
                });
                self.$emit('closeDialog', {
                  type: 'success',
                  openDialog: false,
                  data:params
                });
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      this.$emit('closeDialog', {
        type: 'error',
        openDialog: false
      });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/study/shuati/part/Edit.vue